import apiService from '@/util/request.js';
import SMP_CONFIG from '@/util/smp_config';
import utils from '@/util/utils';
import { merge } from 'lodash';

/**
 * module that contains api functions for event tracking
 * @module trackingApiService */

/**
 * send an event with info about what happened, application type, version etc
 * @param {String} params.section name of an event
 * @param {String} params.value4 location href
 * @returns {AxiosPromise<any>}
 */
const trackWithFg = (params) => {
  const LOCATIONID = SMP_CONFIG.contextConfig.locationId;
  const CONTEXT_KEY = SMP_CONFIG.contextConfig.key;

  let tracking = {
    appName: SMP_CONFIG.applicationType,
    appVersion: utils.applicationVersion(),
    type: LOCATIONID + '-' + CONTEXT_KEY,
    url: location.href
  };

  tracking = merge(tracking, params);

  return apiService.post('/event-collector/json', tracking);
};

export default {
  trackWithFg
}
